<template>
    <div>
        <div class="mask" v-if="showCollectionSuccessToast" @click="collectionShowClose()" @touchmove.prevent @mousewheel.prevent></div>
        <div class="pop2" v-if="showCollectionSuccessToast">
            <div class="no" @click="collectionShowClose()"><img src="@/assets/newImages/home/cover-close.png" alt=""></div>
            <div class="pop-main">
                <p v-if="!showCollectionCancelToast">收藏成功<br>请前往个人中心查看收藏内容</p>
                <p v-if="showCollectionCancelToast">已取消收藏</p>
                <div class="button"  @click="collectionShowClose()">好的</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
    },
    computed:{
        showCollectionSuccessToast(){
            return this.$store.state.showCollectionSuccessToast;
        },
        showCollectionCancelToast(){
            return this.$store.state.showCollectionCancelToast;
        },
    },
    methods:{
        collectionShowClose(){
            this.$store.commit('showCollectionSuccessToast', false);
        }
    }
}
</script>

<style  scoped lang="scss">
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    z-index: 1000;
    cursor: pointer;
}
.pop2{
    background: #fff;
    width: pxToVw(549);
    // height: pxToVw(272);
    height: auto;
    position: fixed;
    z-index:10001;
    left:50% ;
    transform: translate(-50%,-50%);
    top: 50%;
    padding: pxToVw(0) pxToVw(0) pxToVw(67);
    border-radius: 9px;
    .no{
        width: pxToVw(19);
        height: pxToVw(19);
        position: absolute;
        right: pxToVw(24);
        top: pxToVw(24);
        cursor: pointer;
        img{
            width: 100%;
        }
    }
    .pop-main{
        .pop-img{
            margin: pxToVw(64) auto pxToVw(29);
            width: pxToVw(55);
            height:pxToVw(52);
            img{
                width: 100%;
                vertical-align: top;
            }
        }
        p{
            margin: pxToVw(64) auto 0;
            font-size: pxToVw(19);
            font-weight: normal;
            color: #666666;
            line-height: pxToVw(32);
            text-align: center;
            padding: 0;
        }
        .button{
            margin:  pxToVw(24) auto 0;
            width: pxToVw(200);
            height: pxToVw(53);
            background: #C50819;
            font-size: pxToVw(19);
            color: #FFF;
            text-align: center;
            line-height: pxToVw(53);
            border-radius: 3px;
            cursor: pointer;
            margin-top:  pxToVw(15);
        }
    }
}
@media screen and (max-width:767px) {
    .mask{
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,0.5);
        z-index: 1000;
        cursor: pointer;
    }
    .pop2{
        background: #fff;
        width: 82.4vw;
        // height: 41.3vw;
        height: auto;
        position: fixed;
        z-index:10001;
        left:50% ;
        transform: translate(-50%,-50%);
        top: 50%;
        padding: 0 0 9.6vw;
        border-radius: 1.1vw;
        .no{
            width: 2.8vw;
            height: 2.7vw;
            position: absolute;
            right: 3.6vw;
            top: 2.8vw;
            cursor: pointer;
            img{
                width: 100%;
            }
        }
        .pop-main{
            .pop-img{
                margin: 10.9vw auto 2.9vw;
                width: 8.2vw;
                height:7.8vw;
                img{
                    width: 100%;
                    vertical-align: top;
                }
            }
            p{
                margin: 10.9vw auto 0;
                font-size: 3.2vw;
                font-weight: normal;
                color: #666666;
                line-height: 4.8vw;
                text-align: center;
                padding: 0;
                margin-bottom: 3.7vw;
            }
            .button{
                width: 30.1vw;
                height: 8vw;
                background: #C50819;
                font-size: 3.2vw;
                color: #FFF;
                margin: 0 auto;
                text-align: center;
                line-height: 8vw;
                border-radius: 0.3vw;
            }
        }
    }
}
</style>